<template>
  <q-header class="main-header header-scrolled">
    <div class="utility-bar gt-sm">
      <div class="utility-bar__inner">
        <span>Golden Key</span>
        <span>Encontre o espaço certo para si</span>
      </div>
    </div>
    <q-toolbar class="toolbar-inner">

      <!-- Logo -->
      <q-toolbar-title shrink>
        <div class="row items-center no-wrap cursor-pointer" @click="navigateTo('/')">
          <q-icon class="logo-icon" size="64px">
            <img src="./../assets/GKPNGv1.png" alt="Golden Key" />
          </q-icon>
        </div>
      </q-toolbar-title>

      <q-space />

      <!-- Desktop Nav -->
      <nav class="gt-sm row items-center q-gutter-lg">
        <span
          class="nav-link"
          :class="{ 'nav-link--active': tab === 'inicio' }"
          @click="navigateTo('/', 'inicio')"
        >
          Início
        </span>

        <span class="nav-link" :class="{ 'nav-link--active': tab === 'imoveis' }" @click="navigateTo('/imoveis-search', 'imoveis')">Imóveis</span>
        <span class="nav-link" :class="{ 'nav-link--active': tab === 'alojamentos' }" @click="navigateTo('/alojamentos', 'alojamentos')">Alojamentos</span>
        <span class="nav-link" :class="{ 'nav-link--active': tab === 'rent-a-car' }" @click="navigateTo('/rent-a-car', 'rent-a-car')">Rent-a-car</span>

        <span
          class="nav-link"
          :class="{ 'nav-link--active': tab === 'sobre' }"
          @click="navigateTo('/sobre', 'sobre')"
        >
          Sobre Nós
        </span>

        <span
  class="nav-link support-link"
  :class="{ 'nav-link--active': tab === 'suporte' }"
  @click="navigateTo('/suporte', 'suporte')"
>
  <q-icon name="support_agent" size="18px" class="q-mr-xs" />
  Suporte
</span>

      </nav>

      <!-- Desktop CTA -->
      <q-btn
        class="gt-sm q-ml-xl cta-btn"
        color="secondary"
        text-color="white"
        label="Anunciar Imóvel"
        icon="add"
        unelevated
        no-caps
        rounded
        @click="handleAnunciar"
      />

      <!-- Mobile Hamburger -->
      <q-btn
        class="lt-md"
        flat
        dense
        round
        color="grey-9"
        icon="menu"
        @click="drawer = !drawer"
      />
    </q-toolbar>
  </q-header>

  <!-- Mobile Drawer -->
  <q-drawer
    v-model="drawer"
    overlay
    behavior="mobile"
    side="right"
    :width="310"
    class="drawer-root"
  >
    <q-scroll-area class="fit">

      <!-- Header -->
      <div class="dnav-header">
        <div class="dnav-header__brand">
          <img src="./../assets/GKPNGv1.png" alt="Golden Key" class="dnav-logo" />
          <div>
            <div class="dnav-header__name">Golden Key</div>
            <div class="dnav-header__sub">Imobiliária de confiança</div>
          </div>
        </div>
        <button class="dnav-close" @click="drawer = false" aria-label="Fechar menu">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <!-- Nav -->
      <nav class="dnav-body">

        <!-- Início -->
        <div
          class="dnav-item"
          :class="{ 'dnav-item--active': tab === 'inicio' }"
          @click="navigateTo('/', 'inicio')"
        >
          <span class="dnav-item__bar"></span>
          <span class="dnav-item__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round" width="19" height="19">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </span>
          <span class="dnav-item__label">Início</span>
        </div>

        <!-- Divider label -->
        <div class="dnav-section-label">Explorar</div>

        <div class="dnav-item" :class="{ 'dnav-item--active': tab === 'imoveis' }" @click="navigateTo('/imoveis-search', 'imoveis')">
          <span class="dnav-item__bar"></span>
          <span class="dnav-item__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="19" height="19">
              <path d="M4 21V6l8-3 8 3v15"/>
              <path d="M2 21h20M8 8h1M8 12h1M8 16h1M15 8h1M15 12h1M15 16h1"/>
            </svg>
          </span>
          <span class="dnav-item__label">Imóveis</span>
        </div>
        <div class="dnav-item" :class="{ 'dnav-item--active': tab === 'alojamentos' }" @click="navigateTo('/alojamentos', 'alojamentos')">
          <span class="dnav-item__bar"></span>
          <span class="dnav-item__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="19" height="19">
              <path d="M3 20v-9h18v9M3 16h18M7 11V7h5a3 3 0 0 1 3 3v1"/>
              <path d="M6 20v2M18 20v2"/>
            </svg>
          </span>
          <span class="dnav-item__label">Alojamentos</span>
        </div>
        <div class="dnav-item" :class="{ 'dnav-item--active': tab === 'rent-a-car' }" @click="navigateTo('/rent-a-car', 'rent-a-car')">
          <span class="dnav-item__bar"></span>
          <span class="dnav-item__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="19" height="19">
              <path d="M5 17h14l1-5-2-5H6l-2 5 1 5zM3 12h18"/>
              <circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>
            </svg>
          </span>
          <span class="dnav-item__label">Rent-a-car</span>
        </div>

        <!-- Sobre Nós -->
        <div class="dnav-section-label">Empresa</div>
        <div
          class="dnav-item"
          :class="{ 'dnav-item--active': tab === 'sobre' }"
          @click="navigateTo('/sobre', 'sobre')"
        >
          <span class="dnav-item__bar"></span>
          <span class="dnav-item__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round" width="19" height="19">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </span>
          <span class="dnav-item__label">Sobre Nós</span>
        </div>
     

        <!-- Suporte -->
<div
  class="dnav-item"
  :class="{ 'dnav-item--active': tab === 'suporte' }"
  @click="navigateTo('/suporte', 'suporte')"
>
  <span class="dnav-item__bar"></span>

  <span class="dnav-item__icon">
    <svg viewBox="0 0 24 24"
         fill="none"
         stroke="currentColor"
         stroke-width="1.8"
         stroke-linecap="round"
         stroke-linejoin="round"
         width="19"
         height="19">

      <path d="M4 13a8 8 0 0 1 16 0"/>
      <path d="M18 19c0 1-1 2-2 2h-3"/>
      <rect x="3" y="12" width="4" height="6" rx="2"/>
      <rect x="17" y="12" width="4" height="6" rx="2"/>

    </svg>
  </span>

  <span class="dnav-item__label">
    Suporte
  </span>
</div>

      </nav>

      <!-- CTA -->
      <div class="dnav-cta-wrap">
        <button class="dnav-cta" @click="handleAnunciar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round" width="16" height="16">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Anunciar Imóvel
        </button>
      </div>

    </q-scroll-area>
  </q-drawer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';

const tab = ref('inicio');
const drawer = ref(false);
const scrolled = ref(false);
const route = useRoute();

watch(
  () => route.path,
  (path) => {
    if (path.startsWith('/alojamentos')) tab.value = 'alojamentos';
    else if (path.startsWith('/rent-a-car')) tab.value = 'rent-a-car';
    else if (path.startsWith('/imovel') || path.startsWith('/imoveis')) tab.value = 'imoveis';
    else if (path.startsWith('/sobre')) tab.value = 'sobre';
    else if (path.startsWith('/suporte')) tab.value = 'suporte';
    else tab.value = 'inicio';
  },
  { immediate: true }
);

const handleScroll = () => { scrolled.value = window.scrollY > 20; };

const navigateTo = (route, name) => {
  if (name) tab.value = name;
  drawer.value = false;
  router.push(route);
};

const handleAnunciar = () => {
  drawer.value = false;
  window.location.href = 'https://portal.goldenkey.co.mz/';
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap');

/* ── Header ─────────────────────────────── */
.main-header {
  background: #ffffff !important;
  border-bottom: 1px solid #E6E0D6 !important;
  box-shadow: none !important;
}

.utility-bar {
  height: 38px;
  background: #14110E;
  color: #ffffff;
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.6875rem;
  letter-spacing: 0.04em;
}

.utility-bar__inner {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 48px;
}

.toolbar-inner {
  box-sizing: border-box;
  min-height: 77px;
  padding: 0 48px;
  width: 100%;
}

/* ── Nav links ──────────────────────────── */
.nav-link {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.055em;
  color: #1e293b;
  cursor: pointer;
  position: relative;
  padding-bottom: 3px;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1.5px;
  background: #EBA301;
  transition: width 0.28s ease;
  border-radius: 2px;
}

.nav-link:hover { color: #EBA301; }
.nav-link:hover::after,
.nav-link--active::after { width: 100%; }

.nav-link--active {
  color: #EBA301 !important;
  font-weight: 600;
}

.nav-link--dropdown {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  user-select: none;
}

.dropdown-arrow {
  opacity: 0.55;
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.nav-link:hover .dropdown-arrow {
  opacity: 0.9;
}

/* ── Dropdown panel ─────────────────────── */
.options-menu {
  border-radius: 10px !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.10), 0 2px 10px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  overflow: hidden;
}

.options-list {
  padding: 6px;
  min-width: 172px;
}

.options-item {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #334155;
  padding: 0.45rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.14s ease, color 0.14s ease;
  margin-bottom: 1px;
  white-space: nowrap;
}

.options-item:hover {
  background: #f0f7ff;
  color: #027BE3;
}

.options-empty {
  font-size: 0.775rem;
  color: #cbd5e1;
  padding: 0.45rem 0.75rem;
}

/* ── CTA button ─────────────────────────── */
.cta-btn {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.05em !important;
  padding: 7px 18px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(235, 163, 1, 0.38);
}

/* ── Logo ───────────────────────────────── */
.logo-icon {
  filter: none;
}

@media (max-width: 1023px) {
  .toolbar-inner {
    min-height: 68px;
    padding: 0 24px;
  }

  .logo-icon { font-size: 54px !important; }
}

@media (max-width: 479px) {
  .toolbar-inner { min-height: 60px; padding: 0 16px; }
  .logo-icon { font-size: 48px !important; }
}

/* ── Drawer root ────────────────────────── */
.drawer-root {
  background: #ffffff !important;
}

/* ── Header ─────────────────────────────── */
.dnav-header {
  background: #0a1628;
  padding: 22px 20px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dnav-header__brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dnav-logo {
  height: 44px;
  width: auto;
  filter: brightness(0) invert(1);
  opacity: 0.92;
}

.dnav-header__name {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.975rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.2;
  letter-spacing: 0.01em;
}

.dnav-header__sub {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.7rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 2px;
  letter-spacing: 0.02em;
}

.dnav-close {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
  flex-shrink: 0;
}

.dnav-close:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}

/* ── Body ───────────────────────────────── */
.dnav-body {
  padding: 12px 0 8px;
}

.dnav-section-label {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #cbd5e1;
  padding: 14px 24px 4px;
}

/* ── Nav item ───────────────────────────── */
.dnav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 20px 13px 24px;
  cursor: pointer;
  position: relative;
  transition: background 0.18s ease;
}

.dnav-item:hover {
  background: #f8fafc;
}

.dnav-item__bar {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 3px;
  height: 60%;
  border-radius: 0 3px 3px 0;
  background: #EBA301;
  transition: transform 0.22s ease;
}

.dnav-item--active .dnav-item__bar {
  transform: translateY(-50%) scaleY(1);
}

.dnav-item__icon {
  flex-shrink: 0;
  color: #94a3b8;
  display: flex;
  align-items: center;
  transition: color 0.18s ease;
}

.dnav-item--active .dnav-item__icon,
.dnav-item--open .dnav-item__icon {
  color: #EBA301;
}

.dnav-item__label {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #334155;
  flex: 1;
  transition: color 0.18s ease, font-weight 0.18s ease;
}

.dnav-item--active .dnav-item__label {
  color: #0f172a;
  font-weight: 700;
}

.dnav-item--open .dnav-item__label {
  color: #0f172a;
  font-weight: 600;
}

.dnav-item__chevron {
  flex-shrink: 0;
  color: #cbd5e1;
  transition: transform 0.24s ease, color 0.18s ease;
}

.dnav-item--open .dnav-item__chevron {
  transform: rotate(180deg);
  color: #EBA301;
}

/* ── Sub-list ───────────────────────────── */
.dnav-sub-list {
  background: #f8fafc;
  border-left: 2px solid #f1f5f9;
  margin: 0 0 4px 36px;
  border-radius: 0 0 8px 0;
  overflow: hidden;
}

.dnav-sub-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.845rem;
  font-weight: 400;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.dnav-sub-item:hover {
  background: #eef2ff;
  color: #027BE3;
}

.dnav-sub-item__dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
  transition: background 0.15s ease;
}

.dnav-sub-item:hover .dnav-sub-item__dot {
  background: #027BE3;
}

.dnav-sub-empty {
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.78rem;
  color: #cbd5e1;
  padding: 10px 20px;
}

/* Sub-list transition */
.dnav-sub-enter-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.dnav-sub-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}
.dnav-sub-enter-from,
.dnav-sub-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ── Loading dots ───────────────────────── */
.dnav-loading {
  display: flex;
  gap: 6px;
  padding: 16px 24px;
  align-items: center;
}

.dnav-loading__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  animation: dnav-pulse 1.2s ease-in-out infinite;
}

.dnav-loading__dot:nth-child(2) { animation-delay: 0.2s; }
.dnav-loading__dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes dnav-pulse {
  0%, 100% { opacity: 0.3; transform: scale(0.85); }
  50%       { opacity: 1;   transform: scale(1); }
}

/* ── CTA ────────────────────────────────── */
.dnav-cta-wrap {
  padding: 16px 20px 28px;
  border-top: 1px solid #f1f5f9;
  margin-top: 8px;
}

.dnav-cta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  background: #EBA301;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.dnav-cta:hover {
  background: #d49200;
  box-shadow: 0 6px 18px rgba(235, 163, 1, 0.38);
  transform: translateY(-1px);
}
</style>
